import { render, staticRenderFns } from "./VendorOverviewTab.vue?vue&type=template&id=36dc3c68&"
import script from "./VendorOverviewTab.vue?vue&type=script&lang=js&"
export * from "./VendorOverviewTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports